import axios from "./../../config/axios";

function all() {
    return axios().get("/sales-scheduling/priorities");
}

export default {
    all
}